export const FUZZY_NUMBER_TYPES = {
  percent: {
    base: 1000,
    units: ['%'],
  },
  numberUpper: {
    base: 1000,
    units: ['', ' Thousand', ' Million', ' Billion', ' Trillion'],
  },
  number: {
    base: 1000,
    units: ['', ' thousand', ' million', ' billion', ' trillion'],
  },
  numberShort: {
    base: 1000,
    units: ['', 'K', 'M', 'B', 'T'],
  },
  bits: {
    base: 1024,
    units: ['', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb'],
  },
  bytes: {
    base: 1024,
    units: ['', 'KB', 'MB', 'GB', 'TB', 'PB'],
  },
  bitRate: {
    base: 1024,
    units: ['', 'Kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps'],
  },
  byteRate: {
    base: 1024,
    units: ['', 'KBps', 'MBps', 'GBps', 'TBps', 'PBps'],
  },
};

export const fuzzyNumberFilterModule = angular
  .module('Q.filters.fuzzy-number', [])

  .filter('fuzzyNumber', function ($filter) {
    return function (
      number,
      type = 'number',
      sigfigs = 3,
      alwaysShowSign = false,
    ) {
      if (!angular.isNumber(number)) return '';
      const opts = FUZZY_NUMBER_TYPES[type];
      const base = opts.base;
      const units = opts.units;

      let unitIndex = units.length - 1;
      let adjustedNumber = number;
      let fractionSize = 0;

      while (unitIndex > 0) {
        if (number >= Math.pow(base, unitIndex)) {
          adjustedNumber = number / Math.pow(base, unitIndex);
          break;
        }
        unitIndex--;
      }

      const floorNumber = Math.floor(adjustedNumber);
      if (floorNumber !== adjustedNumber) {
        const len = floorNumber.toFixed(0).length;
        if (len < sigfigs) {
          fractionSize = sigfigs - len;
        }
      }

      let formattedNumber = $filter('number')(adjustedNumber, fractionSize)
        .replace(/(\.\d*?)0+$/, '$1')
        .replace(/\.$/, ''); // remove trailing zeroes

      if (alwaysShowSign && number > 0) {
        formattedNumber = '+' + formattedNumber;
      }

      return formattedNumber + units[unitIndex];
    };
  });
